import React from "react";
// import chevronLeft from "../../images/chevron-left.svg"
// import chevronRight from "../../images/chevron-right.svg"

const Subheader = ({ onPrevYear, onNextYear }) => {
  return (
    <div className="bg-theme py-7 mt-5">
      <div className="container mx-auto lg:px-8 px-4">
        <div
          className={`flex items-center justify-center md:flex-row flex-col gap-5`}
        >
          <div>
            <h1 className="md:text-4xl text-2xl font-bold text-white">
            Planlægger
            </h1>
          </div>
          <div>
            <button
              className="rounded-full hover:bg-[#ceeaff4d]"
              onClick={onPrevYear}
            >
              {/* <img src={chevronLeft} className="w-9 h-9 p-1" alt="" /> */}
            </button>
            <button
              className="rounded-full hover:bg-[#ceeaff4d]"
              onClick={onNextYear}
            >
              {/* <img src={chevronRight} className="w-9 h-9 p-1" alt="" /> */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subheader;
